export default class SearchLayer {
  constructor() {
    this.searchLayerElementSelector = '.js-swa-search-layer';
    this.searchLayerCloseSelector = '.js-swa-search-layer-close';
    this.searchIconOpenSelector = '.js-swa-search-layer-icon';
    this.headerOverlaySelector = '.swa-header__overlay';
  }

  init() {
    this.searchLayerElement = document.querySelector(this.searchLayerElementSelector);
    this.searchLayerClose = document.querySelector(this.searchLayerCloseSelector);
    this.searchIconOpen = document.querySelectorAll(this.searchIconOpenSelector);
    this.headerOverlay = document.querySelector(this.headerOverlaySelector);
    this.recentSearchesItemContainer = document.querySelector('.swa-recent-search__list');
    this.headerBottomSlot = document.querySelector('.swa-header__bottom-slot');
    this.searchLayerInputField = this.searchLayerElement && this.searchLayerElement.querySelector('.swa-search-layer__input .swa-form-input__field');

    if (!this.searchLayerElement) {
      return;
    }
    this.searchIconOpen.forEach(searchIcon => {
      searchIcon.addEventListener('click', (e) => {
        this.openLayer(e);
      });
    });

    this.searchLayerClose.addEventListener('click', () => {
      this.closeLayer();
    });

    this.headerOverlay.addEventListener('click', () => {
      if (this.searchLayerElement.classList.contains('swa-search-layer--visible')) {
        this.closeLayer();
      }
    });

    if(this.recentSearchesItemContainer) {
      this.recentSearchesItemContainer.addEventListener('click', (event) => {
        this.onCloseIconClicked(event);
      });
    }

    this.searchSuggestionsInputHandlers();
  }

  onCloseIconClicked(event) {
    if(event.target.classList.contains('swa-recent-search__list-item-close-icon')){
      event.target.closest('.swa-recent-search__list-item-container').remove();
    }
  }

  openLayer(e) {
    e.preventDefault();
    const body = document.querySelector('body');

    this.searchLayerElement.classList.add('swa-search-layer--visible');
    if (this.searchLayerInputField) {
      this.searchLayerInputField.focus();
    }

    // timeout needed in order to make sure that other similar actions from other js files don't affect this behaviour
    setTimeout(() => {
      if (this.headerOverlay) {
        this.headerOverlay.classList.add('swa-active');
      }

      this.headerBottomSlot.style.zIndex = '7';
      body.classList.add('swa-no-scroll');
    }, 0);
  }

  searchSuggestionsInputHandlers() {
    const sections = this.searchLayerElement.querySelector(".js-swa-search-layer__suggestions-sections");
    const autoSuggest = this.searchLayerElement.querySelector(".js-swa-search-layer__auto-suggest");

    if(sections && autoSuggest) {
      this.searchLayerInputField.addEventListener("input", (event) => {
        if(event.target.value) {
          sections.classList.add("swa-hidden");
          autoSuggest.classList.remove("swa-hidden");
        } else {
          sections.classList.remove("swa-hidden");
          autoSuggest.classList.add("swa-hidden");
        }
      });
    }
  }

  closeLayer() {
    const body = document.querySelector('body');

    this.searchLayerElement.classList.remove('swa-search-layer--visible');

    // timeout needed in order to make sure that other similar actions from other js files don't affect this behaviour
    setTimeout(() => {
      if (this.headerOverlay) {
        this.headerOverlay.classList.remove('swa-active');
      }

      this.headerBottomSlot.removeAttribute('style');
      body.classList.remove('swa-no-scroll');
    }, 0);
  }
}
